import React from "react";
import styled, { withTheme } from "styled-components";
import { cheddar } from "@vitalsource/vstui/colors";

const CandyStripeLoader = styled.div`
  @-moz-keyframes slide {
    100% {
      width: 100%;
      background-position: -50%;
    }
  }
  @-webkit-keyframes slide {
    100% {
      width: 100%;
      background-position: -50%;
    }
  }
  @keyframes slide {
    100% {
      width: 100%;
      background-position: -50%;
    }
  }

  background: #ff0000;
  background-image: repeating-linear-gradient(
    -45deg,
    ${props =>
      (props.theme.color ? props.theme.color.secondary : cheddar).getShade(2)},
    ${props =>
        (props.theme.color ? props.theme.color.secondary : cheddar).getShade(2)}
      6px,
    ${props =>
        (props.theme.color ? props.theme.color.secondary : cheddar).getShade(6)}
      6px,
    ${props =>
        (props.theme.color ? props.theme.color.secondary : cheddar).getShade(6)}
      12px
  );
  background-repeat: repeat-x;
  background-size: 16px 5px;
  width: 100%;
  height: 5px;
  z-index: 10;
  position: fixed;
  left: 0px;
  right: 0px;
  animation: slide 10s linear infinite;
  bottom: ${props => props.offset + "px" || 0};
`;

const CandyStripe = props => <CandyStripeLoader {...props} />;

export default withTheme(CandyStripe);
